export const deCorrelation = {
  'correlation.pageTitle': 'Korrelationsanalyse',
  'correlation.pageSubtitle': 'Analyse und Visualisierung von Korrelationen zwischen Messpunkten',
  'correlation.placeholderTitle': 'Keine Parameter ausgewählt.',
  'correlation.placeholderDescription': 'Korrelationsergebnis auswählen zur Visualisierung von Daten.',
  'correlation.sectionTitle': 'Wählen Sie Parameter',
  'correlation.submittedCalculations': 'Übermittelte Berechnungen',
  'correlation.correlationsResults': 'Korrelationsergebnisse',
  'correlation.chooseValue': 'Bitte Eintrag wählen',
  'correlation.startNewCalculation': 'Neue Berechnung starten',
  'correlation.tso': 'Übertragungsnetzbetreiber',
  'correlation.tso.required': 'Bitte wählen Sie mindestens einen Übertragungsnetzbetreiber aus.',
  'correlation.start': 'Start',
  'correlation.start.required': 'Bitte wählen Sie ein Startdatum aus.',
  'correlation.end': 'Ende',
  'correlation.end.required': 'Bitte wählen Sie ein Enddatum aus.',
  'correlation.singleParameter': 'Einzelne Kenngröße',
  'correlation.measurementParameter': 'Messgrößen',
  'correlation.measurementParameter.required': 'Bitte wählen Sie einen Wert aus.',
  'correlation.significanceThreshold': 'Signifikanzschwelle |r| >',
  'correlation.significanceThreshold.required': 'Bitte geben Sie einen Dezimalwert zwischen 0 und 1 ein.',
  'correlation.multipleParameters': 'Mehrere Kenngrößen',
  'correlation.enterValue': 'Wert eingeben',
  'correlation.invalidValue': 'Ungültige Wert',
  'correlation.resetAll': 'Verwerfen',
  'correlation.submitCalculation': 'Berechnung übermitteln',
  'correlation.dialogTitle': 'Berechnung übermitteln',
  'correlation.dialogContent':
    'Diese Korrelationsberechnung mit den ausgewählten Parametern kann übermittelt und gespeichert werden. Die Berechnungen finden Sie dann unter „Korrelationsergebnisse”. Sobald die Berechnungen abgeschlossen sind, können sie ausgewählt werden.',
  'correlation.dialogTextfieldTitle': 'Name für Korrelationsberechnung',
  'correlation.dialogTextfieldPlaceholder': 'Name eingeben',
  'correlation.dialogTextfieldHint': 'Hinweis: Erlaubte Zeichen sind a-zA-Z0-9äöüÄÖÜß\s\-_()/.',
  'correlation.dialogTextfieldValidationError':
    'Ungültige Zeichen erkannt. Bitte entfernen Sie nicht unterstützte Symbole.',
  'correlation.dialogTextfieldValidationInvalidName': 'Bitte geben Sie einen gültigen Namen ein.',
  'correlation.cancel': 'Abbrechen',
  'correlation.snackbarSubmitSuccess': 'Berechnung wurde erfolgreich übermittelt und wird nun verarbeitet.',
  'correlation.snackbarSubmitError1': 'Berechnung konnte nicht übermittelt werden. Bitte versuchen Sie es erneut.',
  'correlation.deleteDialogTitle': 'Korrelationsergebnis löschen',
  'correlation.deleteDialogContentPart1': 'Möchtest du "',
  'correlation.deleteDialogContentPart2': '" wirklich löschen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
  'correlation.delete': 'Löschen',
  'correlation.snackbarDeleteSuccess': 'Berechnung wurde erfolgreich gelöscht.',
  'correlation.snackbarDeleteError': 'Berechnung konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.',
  'correlation.legend.single': 'Korrelationskoeffizient',
  'correlation.legend.multiple': 'Korrelierende Messgrößen',
  'correlation.value': 'Wert',
  'correlation.tooltip1': 'von',
  'correlation.tooltip2': 'Kenngrößen überschreiten den Schwellenwert',
  'correlation.tooltip.none': 'Keiner',
  'correlation.couldNotCalculate': 'Keine Berechnung möglich',
  'correlation.matrix': 'Korrelationsmatrix',
  'correlation.matrix.description':
    'Messgeräte ohne verfügbare Daten werden automatisch ausgeblendet und nicht in die Korrelationsberechnung einbezogen.',
};
